import React from 'react';
import { Drawer, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import {
  readUserPreferences,
  saveUserPreferences,
} from '../common/util/userPreferences';
import './UserPreferencesPanel.css';

const SETTING_GROUPS = [
  {
    key: 'themeMode',
    title: '外观主题',
    desc: '控制整站亮色、暗色显示。',
    options: [
      { key: 'system', label: '跟随系统' },
      { key: 'light', label: '亮色' },
      { key: 'dark', label: '暗色' },
    ],
  },
  {
    key: 'fontSize',
    title: '阅读字号',
    desc: '影响语写、阅读、人生规划、出书等文档内容区。',
    options: [
      { key: 'small', label: '小' },
      { key: 'medium', label: '中' },
      { key: 'large', label: '大' },
    ],
  },
  {
    key: 'fontFamily',
    title: '字体风格',
    desc: '为长文阅读或写作选择更舒适的字体。',
    options: [
      { key: 'default', label: '默认' },
      { key: 'serif', label: '宋体阅读' },
      { key: 'mono', label: '等宽写作' },
    ],
  },
];

export default class UserPreferencesPanel extends React.Component {
  state = {
    preferences: readUserPreferences(),
  };

  updatePreference = (key, value) => {
    const preferences = saveUserPreferences({
      ...this.state.preferences,
      [key]: value,
    });
    this.setState({ preferences });
  };

  renderGroup = group => {
    const activeValue = this.state.preferences[group.key];
    return (
      <section className="sj-preference-section" key={group.key}>
        <div>
          <div className="sj-preference-title">{group.title}</div>
          <div className="sj-preference-desc">{group.desc}</div>
        </div>
        <div className="sj-preference-options" role="group" aria-label={group.title}>
          {group.options.map(option => {
            const active = option.key === activeValue;
            return (
              <Button
                key={option.key}
                type={active ? 'primary' : 'default'}
                className="sj-preference-option"
                aria-pressed={active}
                onClick={() => this.updatePreference(group.key, option.key)}
              >
                {active && <CheckOutlined />}
                {option.label}
              </Button>
            );
          })}
        </div>
      </section>
    );
  };

  render() {
    return (
      <Drawer
        title="用户设置"
        placement="right"
        width={420}
        open={this.props.visible}
        onClose={this.props.onClose}
        className="sj-preferences-drawer"
        aria-label="用户设置"
      >
        <div className="sj-preferences-panel">
          {SETTING_GROUPS.map(this.renderGroup)}
        </div>
      </Drawer>
    );
  }
}
